import { render } from "./CatalougeView.vue?vue&type=template&id=9294f268&scoped=true"
import script from "./CatalougeView.vue?vue&type=script&lang=js"
export * from "./CatalougeView.vue?vue&type=script&lang=js"

import "./CatalougeView.vue?vue&type=style&index=0&id=9294f268&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9294f268"]])

export default __exports__